<form [formGroup]="careersForm" InvalidControlScroll>
  <div class="row">
    <!-- <div class="col-md-6">
      <div class="jwc_form_group">
        <label>Enquiry type</label>
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">{{inquiryType}}</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="inquiryTypeValue.emit(item)" *ngFor="let item of inquiryData?.inquiryType">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-md-12"></div>
    <!-- <div class="col-md-6">
      <div class="jwc_form_group">
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">{{ selectedBrand ? selectedBrand : 'Jio World Centre' }}</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="setDropdownValue('brand', item.value);brandValue.emit(item.value);" *ngFor="let item of inquiryData?.cards[0]?.brand">{{item.label}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label>Select option</label>
        <div class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select">{{selectedRole? selectedRole :'Role'}}</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="setDropdownValueRole(Item.position,Item.jobId)" *ngFor="let Item of AllRoles">{{Item?.position}}
              </li>
              <li tabindex="0" (click)="OtherRoleSelected()">Other
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.role.errors">{{errorText}}</div>
    </div>
    <div class="col-md-6" *ngIf="careersForm.value.role=='Other'">
      <div class="jwc_form_group">
        <label for="theRole">Role</label>
        <input id="theRole" type="email" name="" value="" placeholder="Enter the Role" class="form-control jwc_input"
        formControlName="others">
      </div>
      <div aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.others.errors">{{errorText}}</div>
    </div>
    <div class="col-md-12">
      <div class="jwc_form_title">
        A few more details and you’ll be all set.
      </div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="input_name">Name</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <input aria-describedby="nameError" id="input_name" type="text" name="" value="" placeholder="Name" class="form-control jwc_input"
          formControlName="nameInput" appAllowedInput [alphabetsOnly]="true">
      </div>
      <div aria-live="assertive" id="nameError" *ngIf="(careersFormControls.nameInput.touched || submitted) && careersFormControls.nameInput.errors">
        <div *ngIf="careersFormControls.nameInput.errors.required" class="error-text">{{errorText}}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="input_email">Email</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <input aria-describedby="emailError" id="input_email" type="email" name="" value="" placeholder="Email" class="form-control jwc_input"
          formControlName="emailInput">
      </div>
      <div id="emailError" aria-live="assertive" *ngIf="(careersFormControls.emailInput.touched || submitted) && careersFormControls.emailInput.errors">
        <div *ngIf="careersFormControls.emailInput.errors.required" class="error-text">{{errorText}}</div>
        <div *ngIf="careersFormControls.emailInput.errors.pattern" class="error-text">Email must be a valid email
          address
        </div>
      </div>
    </div>
    <!-- Phone No -->
    <div class="col-md-6">
      <label for="input_phone">Phone number</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
      <div class="jwc_form_group jwc_form_phn">
        <div class="dropdown" (keydown)="handleDropdownKeyEvents($event)" #dropdown  aria-label="Country Code" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div (click)="toggleDropdown()" aria-haspopup="listbox" [attr.aria-expanded]="isDropdownOpen" aria-controls="country-code-list" class="dropdown--select">{{selectedCountryCode}}</div>
          <div id="tooltip-cc" role="tooltip" class="visually-hidden">
            Country Code: Select your country
          </div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul id="country-code-list" role="listbox"> 
              <li tabindex="0"  (keydown)="handleKeydown($event, item)" (click)="setDropdownValue('countryCode', item)" *ngFor="let item of generalArrData?.countryCode">
                {{item}}</li>
            </ul>
          </div>
        </div>
        <input aria-describedby="phoneError" type="text" name="" value="" placeholder="Phone Number" class="form-control jwc_input" id="input_phone"
          formControlName="phoneNoInput" maxlength="10" appAllowedInput [numbersOnly]="true">
      </div>
      <div id="phoneError" aria-live="assertive" class="error-text"
        *ngIf="(careersFormControls.phoneNoInput.touched || submitted) && careersFormControls.phoneNoInput.errors">
        Enter 10 digit Mobile Number</div>
    </div>
    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="input_linkedIN">LinkedIn URL</label>
        <input aria-describedby="linkedinError" id="input_linkedIN" type="text" name="" value="" placeholder="LinkedIn URL" class="form-control jwc_input"
          formControlName="urlInput">
      </div>
      <div id="linkedinError" *ngIf="(careersFormControls.urlInput.touched || submitted) && careersFormControls.urlInput.errors">
        <div *ngIf="careersFormControls.urlInput.errors.pattern" class="error-text">Enter valid url</div>
      </div>
    </div>



    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="ageDropdown">Age</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <div aria-describedby="ageError" class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select" id="ageDropdown">Age</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="this.careersForm.get('age').setValue(Item)" *ngFor="let Item of AgeDropdown">
                {{Item}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="ageError" aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.age.errors">{{errorText}}</div>
    </div>

    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="genderDropdown">Gender</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <div aria-describedby="genderError" class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select"  id="genderDropdown">Gender</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="this.careersForm.get('gender').setValue(Item)" *ngFor="let Item of GenderDropdown">
                {{Item}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="genderError" aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.gender.errors">{{errorText}}</div>
    </div>

    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="qualDropdown">Qualification</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <div aria-describedby="qualificationError" class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select" id="qualDropdown">Qualification</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="this.careersForm.get('qualification').setValue(Item)" *ngFor="let Item of EducationDropdown">
                {{Item}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="qualificationError" aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.qualification.errors">{{errorText}}</div>
    </div>

    <div class="col-md-6">
      <div class="jwc_form_group">
        <label id="experDropdown">Experience</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <div aria-describedby="experienceError" class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select" id="experDropdown">Experience</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <ul>
              <li tabindex="0" (click)="this.careersForm.get('experience').setValue(Item)" *ngFor="let Item of ExperienceDropdown">
                {{Item}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="experienceError" aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.experience.errors">{{errorText}}</div>
    </div>

    <div class="col-md-6">
      <div class="jwc_form_group">
        <label id="stateDropdown">State</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <div aria-describedby="stateError" class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div class="dropdown--select" id="stateDropdown">State</div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <input class="col-md-12 serchText" placeholder="Search" type="text" [(ngModel)]="serchText" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterLocation('state')">
            <ul>
              <span *ngIf="filterdState?.length==0">
                <li tabindex="0" (click)="setState('state',Item.state)" *ngFor="let Item of LocationDropdown">
                  {{Item.state}}
                </li>
              </span>
             <span *ngIf="filterdState?.length!=0">
              <li tabindex="0" (click)="setState('state',Item.state)" *ngFor="let Item of filterdState">
                {{Item.state}}
              </li>
             </span>
            </ul>
          </div>
        </div>
      </div>
      <div id="stateError" aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.currentState.errors">{{errorText}}</div>
    </div>

    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="cityDropdown">City</label><span _ngcontent-serverapp-c92="" class="text-danger">* </span>
        <div aria-describedby="cityError" class="dropdown" role="button" aria-labelledby="dropdown-label" tabindex="0">
          <div id="cityDropdown" class="dropdown--select" [innerHTML]="careersForm.value.currentCity ? careersForm.value.currentCity :'City'"></div>
          <div class="dropdown--list" aria-expanded="false" role="list">
            <input class="col-md-12 serchText" placeholder="Search" type="text" [(ngModel)]="serchText" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterLocation('city')">
            <ul>
              <span *ngIf="filterdCity?.length==0">
                <li tabindex="0" (click)="setState('city',Item)" *ngFor="let Item of LocationDropdown[index]?.cities">
                  {{Item}}
                </li>
              </span>
              <span *ngIf="filterdCity?.length!=0">
                <li tabindex="0" (click)="setState('city',Item)" *ngFor="let Item of filterdCity">
                  {{Item}}
                </li>
              </span>
            </ul>
          </div>
        </div>
      </div>
      <div id="cityError" aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.currentCity.errors">{{errorText}}</div>
    </div>

    <div class="col-md-6">
      <div class="jwc_form_group">
        <label for="input_currOrg">Current organisation</label>
        <input id="input_currOrg" type="email" name="" value="" placeholder="Current Organisation" class="form-control jwc_input"
        formControlName="currentOrganisation">
      </div>
    </div>

    
    <div class="col-md-12">
      <div class="jwc_form_title">
        Attach Resume (docx/doc/pdf)(Size 5MB)
      </div>
    </div>
    <div class="col-lg-6">
      <label for="resumeUpload">Choose your file</label>
      <div class="jwc_form_group jwc_file_group">
        <!-- <input type="file" id="file" class="jwc_file form-control"> -->
        <input id="resumeUpload" type="file" formControlName="fileInput" (change)="handleFileInput($event.target.files)">
      </div>
      <div aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.fileInput.errors">{{errorText}}</div>
      <div class="error-text" *ngIf="fileTypeError">{{fileTypeError}}</div>
      <div class="error-text" *ngIf="fileSizeError">{{fileSizeError}}</div>
    </div>

    <div class="col-md-12">
      <div class="jwc_form_group">
        <label for="coverLetter" class="jwc_form_title">Cover Letter</label>
        <textarea id="coverLetter" name="" class="form-control jwc_textarea" placeholder="Message" cols="30" rows="10"
          formControlName="messageInput"></textarea>
      </div>
    </div>
    <div class="col-md-12">
      <div class="custom-control custom-checkbox checkbox jwc_form_group">
        <input type="checkbox" class="custom-control-input" id="dontmiss" name="dontmiss" formControlName="firstConsent">
        <label class="custom-control-label consent" for="dontmiss">
          <span class="text-danger">* </span>
          <span class="ml-1">
            I have read, understood, and accept the Jio World Centre <a href="{{'/legal?tab=privacy'}}" 
            (click)="_sharedService.checkCTALink($event, staticUrlForImgNew + '/legal?tab=privacy', '_blank', 'External')">
            Privacy Policy </a>and consent to the sharing of my personal data for the purpose of applying for jobs at JWC or NMACC. 
            I agree that my data is shared with hiring managers considering for potential future purposes.
          </span>
        </label>
      </div>
      <div aria-live="assertive" class="error-text" *ngIf="submitted && careersFormControls.firstConsent.errors">{{errorText}}</div>
    </div>

    <div class="col-md-12">
      <div class="custom-control custom-checkbox checkbox jwc_form_group">
        <input class="custom-control-input" type="checkbox" id="gridCheckForSecondConsent" formControlName="secondConsent">
        <label class="custom-control-label" for="gridCheckForSecondConsent">
            I agree to receive communications regarding personalized services and other relevant 
            information about Jio World Centre and its affiliated services.
        </label>
      </div>
    </div>
    <div class="col-md-12 captcha">
      <re-captcha (resolved)="captchaRes($event)" [siteKey]="captchaSiteKey" (error)="captchaRes($event, true)"
        errorMode="handled"></re-captcha>
      <div aria-live="assertive" class="error-text" style="margin-top:5px" *ngIf="submitted && !isCaptchaSelected">{{errorText}}</div>
    </div>
  </div>
  <div class="jwc_form_group--btn">
    <button type = "submit" [ngClass]="{'disabled':disableBtn}" [disabled] = "disableBtn" class="cta-prim color-gold" (click)="careersFormSubmit(careersForm)"><span
        class="cta-prim-txt">Submit</span></button>
  </div>
  <div class="error-text" style="margin-top:5px" *ngIf="apiErrorMsg">{{apiErrorMsg}}</div>
</form>